import React from "react";
import moment from "moment";
import TextFirstAlphabetAsIcon from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/TextFirstAlphabetAsIcon";
import { addCommasWithoutDecimal } from "@domains/utils/numberMethods";
var textAndBackgroundColorCollectionForSchemeName = {
    textColor: "txt_dark-purple",
    backgroundColor: "bg_blush-pink",
};
var LinkedSipCard = function (props) {
    var logo = props.logo, schemeName = props.schemeName, trxAmount = props.trxAmount, trxDate = props.trxDate;
    var updatedTrxDate = moment(trxDate).format("DD MMM YYYY");
    return (React.createElement("article", { className: "primary-linked-sip-card-container d-flex align-items-center gap" },
        logo ? (React.createElement("img", { src: logo, alt: "", className: "fund-icon" })) : (React.createElement(React.Fragment, null,
            React.createElement(TextFirstAlphabetAsIcon, { textToExtractWordFrom: schemeName, textAndBackgroundColorCollection: textAndBackgroundColorCollectionForSchemeName }))),
        React.createElement("div", { className: "fund-details d-flex flex-column" },
            React.createElement("h3", { className: "fund-name DMSans_13_400" }, schemeName),
            React.createElement("div", { className: "fund-info d-flex align-items-center" },
                React.createElement("span", { className: "RobotoM_13_400 txt_midnight-blue-shade2" },
                    "\u20B9 ",
                    addCommasWithoutDecimal(trxAmount)),
                React.createElement("span", { className: "fw-light txt_dull-grey" }, "|"),
                React.createElement("span", { className: "DMSansNormal_12_400 txt_medium-gray" }, updatedTrxDate)))));
};
export default LinkedSipCard;
